import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ContentFormCard = ({ children }) => <S.Card>{children}</S.Card>;

export default ContentFormCard;

ContentFormCard.propTypes = {
  children: PropTypes.node.isRequired,
};
